/*
  DPYSR Theme – Animationen und Shop-Logik.
  Alles läuft über eine gemeinsame Uhr (requestAnimationFrame), damit Logo, Stange,
  Laufband und Einblendungen im selben Takt bleiben.
*/
(function () {
  'use strict';

  const doc = document;
  const root = doc.documentElement;
  const T = window.theme || { routes: {}, strings: {} };
  const STR = T.strings || {};
  const RM = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const DESIGN = !!(window.Shopify && window.Shopify.designMode);

  const $ = (s, r) => (r || doc).querySelector(s);
  const $$ = (s, r) => Array.prototype.slice.call((r || doc).querySelectorAll(s));
  const clamp = (v, a, b) => Math.min(b === undefined ? 1 : b, Math.max(a === undefined ? 0 : a, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  const E = {
    lin: (t) => t,
    out: (t) => 1 - Math.pow(1 - t, 3),
    out5: (t) => 1 - Math.pow(1 - t, 5),
    io: (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2),
  };

  /* ------------------------------------------------------------------ Uhr */
  const S = { t: performance.now(), dt: 0.016, sy: window.scrollY, vy: 0, vw: root.clientWidth, vh: window.innerHeight };
  const tweens = new Set();
  const frameFns = [];
  const resizeFns = [];

  function tween(o) {
    const tw = Object.assign({ dur: 700, delay: 0, ease: E.out, from: 0, to: 1 }, o);
    tw.t0 = S.t;
    if (RM) {
      tw.update(tw.to);
      if (tw.done) tw.done();
      return tw;
    }
    tw.update(tw.from);
    tweens.add(tw);
    return tw;
  }
  function onFrame(fn) {
    frameFns.push(fn);
  }
  function onResize(fn) {
    resizeFns.push(fn);
  }

  let lastT = S.t;
  let syPrev = S.sy;
  function frame(t) {
    S.dt = Math.min(0.05, Math.max(0.001, (t - lastT) / 1000));
    lastT = t;
    S.t = t;
    S.sy = window.scrollY;
    tweens.forEach((tw) => {
      const p = clamp((t - tw.t0 - tw.delay) / tw.dur);
      if (p <= 0) return;
      tw.update(tw.from + (tw.to - tw.from) * tw.ease(p));
      if (p >= 1) {
        tweens.delete(tw);
        if (tw.done) tw.done();
      }
    });
    for (let i = frameFns.length - 1; i >= 0; i--) {
      if (frameFns[i](S) === false) frameFns.splice(i, 1);
    }
    S.vy = lerp(S.vy, (S.sy - syPrev) / S.dt, 0.3);
    syPrev = S.sy;
    window.requestAnimationFrame(frame);
  }
  function measureAll() {
    S.vw = root.clientWidth;
    S.vh = window.innerHeight;
    resizeFns.forEach((fn) => fn());
  }

  /* ----------------------------------------------------------------- Logo */
  /* Nachgezeichnete Kontur, die über Masken-Striche "geschrieben" wird. */
  const STROKES = [{"d":"M373,363 L444,362 L468,369 L481,377 L497,394 L504,407 L509,425 L509,449 L504,467 L491,487 L476,500 L462,507 L445,511 L375,512","a":0.0,"b":0.3},{"d":"M599,363 L672,362 L689,369 L698,379 L702,387 L704,398 L702,415 L698,424 L688,435 L678,440 L667,442 L601,443 L601,512","a":0.07,"b":0.38},{"d":"M784,358 L788,360 L845,466 L850,475 L854,478","a":0.17,"b":0.34},{"d":"M1087,372 L1085,373 L1074,366 L1054,360 L1033,360 L1019,364 L1011,369 L1001,380 L997,391 L998,406 L1002,414 L1008,420 L1027,430 L1072,444 L1086,454 L1092,464 L1094,474 L1092,487 L1087,497 L1071,510 L1050,515 L1037,515 L1019,512 L1005,506 L995,499","a":0.22,"b":0.54},{"d":"M1187,362 L1261,362 L1278,368 L1288,378 L1294,391 L1295,400 L1292,416 L1288,424 L1280,433 L1272,438 L1256,442 L1254,442 L1187,443 L1188,511","a":0.3,"b":0.64},{"d":"M1255,443 L1260,453 L1294,492 L1316,513 L1337,528 L1362,541 L1379,547 L1409,554 L1435,556","a":0.6,"b":0.84},{"d":"M538,816 L554,814 L591,803 L632,784 L680,752 L718,717 L756,671 L789,621 L831,540 L853,489 L855,479 L855,478 L859,475 L890,402 L920,340 L949,289 L972,254 L1003,215 L1042,176 L1071,153 L1104,134","a":0.38,"b":1.0}];
  let logoUid = 0;
  function buildLogo(host) {
    if (!doc.getElementById('dpysr-o')) return null;
    const id = 'dpysr-m' + ++logoUid;
    host.innerHTML =
      '<svg viewBox="351 114 1104 723" aria-hidden="true" focusable="false"><mask id="' + id +
      '" maskUnits="userSpaceOnUse" x="331" y="94" width="1144" height="763">' +
      STROKES.map((s) => '<path d="' + s.d + '" fill="none" stroke="#fff" stroke-width="26" stroke-linecap="round" stroke-linejoin="round"/>').join('') +
      '</mask><use href="#dpysr-o" fill="currentColor" mask="url(#' + id + ')"/></svg>';
    const paths = $$('mask path', host);
    const len = paths.map((p) => p.getTotalLength());
    paths.forEach((p, i) => {
      p.style.strokeDasharray = len[i] + ' ' + (len[i] + 80);
    });
    return function (t) {
      paths.forEach((p, i) => {
        const s = STROKES[i];
        let q = clamp((t - s.a) / (s.b - s.a));
        q = i === STROKES.length - 1 ? E.io(q) : E.out(q);
        p.style.strokeDashoffset = len[i] * (1 - q);
        p.style.visibility = q > 0 ? 'visible' : 'hidden';
      });
    };
  }

  function initLogoDraw(scope) {
    $$('[data-logo-draw]', scope).forEach((host) => {
      if (host.__logo) return;
      const set = buildLogo(host);
      if (!set) return;
      host.__logo = set;
      set(1);
      if (RM) return;
      if (host.hasAttribute('data-logo-now')) {
        tween({ dur: 2400, delay: 300, ease: E.lin, update: set });
        return;
      }
      let done = false;
      onFrame((s) => {
        if (!host.isConnected) return false;
        if (done) return false;
        const r = host.getBoundingClientRect();
        if (r.top < s.vh * 0.99 && r.bottom > 0) {
          done = true;
          tween({ dur: 2400, ease: E.lin, update: set });
        }
      });
    });
  }

  /* ---------------------------------------------------------------- Intro */
  let introDelay = 0;
  function initIntro() {
    const intro = doc.getElementById('Intro');
    if (!intro || intro.hidden) return;
    if (RM) {
      intro.hidden = true;
      return;
    }
    const inner = $('[data-intro-inner]', intro);
    const tag = $('[data-intro-tag]', intro);
    const set = buildLogo($('[data-intro-logo]', intro));
    if (!set) {
      intro.hidden = true;
      return;
    }
    try {
      window.sessionStorage.setItem('dpysrIntro', '1');
    } catch (e) {}
    introDelay = 3120;
    const mine = [];
    mine.push(tween({ dur: 2300, ease: E.lin, update: set }));
    if (tag) {
      mine.push(
        tween({
          delay: 1650,
          dur: 900,
          update: (p) => {
            tag.style.opacity = p;
            tag.style.letterSpacing = lerp(0.75, 0.4, p) + 'em';
          },
        })
      );
    }
    mine.push(
      tween({
        delay: 3000,
        dur: 950,
        ease: E.io,
        update: (p) => {
          intro.style.clipPath = 'inset(0 0 ' + p * 100 + '% 0)';
          inner.style.transform = 'translateY(' + -p * 14 + 'vh)';
        },
        done: () => {
          intro.hidden = true;
        },
      })
    );
    const skip = $('[data-intro-skip]', intro);
    const finish = () => {
      tweens.forEach((tw) => tw.update(tw.to));
      tweens.clear();
      intro.hidden = true;
    };
    if (skip) skip.addEventListener('click', finish);
    intro.addEventListener('click', finish);
  }

  /* ----------------------------------------------------------------- Hero */
  function initHero(scope, delay) {
    $$('[data-hero]', scope).forEach((hero) => {
      const lines = $$('[data-hero-line]', hero);
      const script = $('[data-hero-script]', hero);
      const meta = $('[data-hero-meta]', hero);
      const film = $('[data-hero-film]', hero);
      const filmIn = $('[data-hero-film-inner]', hero);
      const video = $('video', hero);
      if (video) {
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('playsinline', '');
        const p = video.play && video.play();
        if (p && p.catch) p.catch(() => {});
      }
      lines.forEach((el, i) =>
        tween({
          delay: delay + i * 95,
          dur: 1100,
          ease: E.out5,
          update: (p) => {
            el.style.transform = 'translateY(' + (1 - p) * 108 + '%)';
          },
        })
      );
      if (script) {
        tween({
          delay: delay + 520,
          dur: 1200,
          ease: E.io,
          update: (p) => {
            script.style.clipPath = 'inset(-20% ' + (1 - p) * 100 + '% -20% 0)';
          },
        });
      }
      if (meta) {
        tween({
          delay: delay + 650,
          dur: 800,
          update: (p) => {
            meta.style.opacity = p;
            meta.style.transform = 'translateY(' + (1 - p) * 18 + 'px)';
          },
        });
      }
      if (film && filmIn) {
        tween({
          delay: delay + 120,
          dur: 1400,
          ease: E.out5,
          update: (p) => {
            film.style.clipPath = 'inset(' + (1 - p) * 100 + '% 0 0 0)';
            filmIn.style.transform = 'scale(' + (1.22 - 0.22 * p) + ')';
          },
        });
      }
      $$('[data-scroll-next]', hero).forEach((a) =>
        a.addEventListener('click', (e) => {
          e.preventDefault();
          const section = hero.closest('.shopify-section');
          const target = $('[data-rail]') || (section && section.nextElementSibling);
          if (target) window.scrollTo({ top: target.getBoundingClientRect().top + window.scrollY, behavior: RM ? 'auto' : 'smooth' });
        })
      );
    });
  }

  /* ------------------------------------------------------------- Laufband */
  function initMarquee(scope) {
    $$('[data-marquee]', scope).forEach((row) => {
      if (row.__marquee) return;
      row.__marquee = true;
      const set = $('.band__set', row);
      if (!set) return;
      const speed = parseFloat(row.dataset.speed) || 46;
      let setW = 1;
      let x = 0;
      const fill = () => {
        $$('.band__set', row).slice(1).forEach((n) => n.remove());
        setW = Math.max(1, set.getBoundingClientRect().width);
        const copies = Math.min(40, Math.ceil((S.vw * 1.2) / setW) + 1);
        for (let i = 0; i < copies; i++) row.appendChild(set.cloneNode(true));
      };
      fill();
      onResize(fill);
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(fill);
      if (RM) return;
      onFrame((s) => {
        if (!row.isConnected) return false;
        x = (x + (speed + Math.min(900, Math.abs(s.vy)) * 0.22) * s.dt) % setW;
        row.style.transform = 'translate3d(' + (-x).toFixed(2) + 'px,0,0)';
      });
    });
  }

  /* --------------------------------------------------------- Kleiderstange */
  /* Bild prüfen: Ist es freigestellt, und wo sitzt das Teil im Bild? */
  function probeImage(url) {
    return new Promise((resolve) => {
      if (!url) return resolve(null);
      let finished = false;
      const fin = (v) => {
        if (finished) return;
        finished = true;
        window.clearTimeout(timer);
        resolve(v);
      };
      const timer = window.setTimeout(() => fin(null), 3000);
      const im = new Image();
      im.crossOrigin = 'anonymous';
      im.onerror = () => fin(null);
      im.onload = () => {
        try {
          const w = Math.min(140, im.naturalWidth);
          const h = Math.max(1, Math.round((w * im.naturalHeight) / im.naturalWidth));
          const c = doc.createElement('canvas');
          c.width = w;
          c.height = h;
          const ctx = c.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(im, 0, 0, w, h);
          const d = ctx.getImageData(0, 0, w, h).data;
          let x0 = w, y0 = h, x1 = -1, y1 = -1, clear = 0;
          for (let y = 0; y < h; y++) {
            for (let x = 0; x < w; x++) {
              if (d[(y * w + x) * 4 + 3] > 40) {
                if (x < x0) x0 = x;
                if (x > x1) x1 = x;
                if (y < y0) y0 = y;
                if (y > y1) y1 = y;
              } else clear++;
            }
          }
          if (x1 < 0) return fin(null);
          const opaque = clear / (w * h) < 0.04;
          const rows = Math.max(2, Math.round((y1 - y0 + 1) * 0.04));
          let sum = 0, cnt = 0;
          for (let y = y0; y < y0 + rows && y < h; y++) {
            for (let x = 0; x < w; x++) {
              if (d[(y * w + x) * 4 + 3] > 40) {
                sum += x + 0.5;
                cnt++;
              }
            }
          }
          fin({
            opaque,
            x0: x0 / w,
            y0: y0 / h,
            x1: (x1 + 1) / w,
            y1: (y1 + 1) / h,
            hx: cnt ? sum / cnt / w : 0.5,
            ar: im.naturalWidth / im.naturalHeight,
          });
        } catch (e) {
          fin(null);
        }
      };
      im.src = url;
    });
  }

  const CARD_ASPECT = 1 / 1.14;
  function fitFace(face, pr) {
    if (!pr || pr.opaque) return;
    const bw = pr.x1 - pr.x0;
    const bh = pr.y1 - pr.y0;
    const fh = Math.min(1 / bh, CARD_ASPECT / (bw * pr.ar));
    face.style.setProperty('--fh', (fh * 100).toFixed(2) + '%');
    face.style.setProperty('--ft', (-pr.y0 * fh * 100).toFixed(2) + '%');
    face.style.setProperty('--fx', (-pr.hx * 100).toFixed(2) + '%');
  }

  function initRail(scope) {
    $$('[data-rail]', scope).forEach((rail) => {
      if (rail.__rail) return;
      rail.__rail = true;
      const pin = $('[data-rail-pin]', rail);
      const track = $('[data-rail-track]', rail);
      const wallType = $('[data-rail-type]', rail);
      const prog = $('[data-rail-prog]', rail);
      const hint = $('[data-rail-hint]', rail);
      const floor = $('[data-rail-floor]', rail);
      const info = $('[data-rail-info]', rail);
      const ui = {
        text: $('[data-rail-text]', rail),
        name: $('[data-rail-name]', rail),
        sub: $('[data-rail-sub]', rail),
        price: $('[data-rail-price]', rail),
        opts: $('[data-rail-opts]', rail),
        count: $('[data-rail-count]', rail),
        flip: $('[data-rail-flip]', rail),
        add: $('[data-rail-add]', rail),
      };
      const pieces = $$('[data-piece]', rail).map((el, i) => {
        const d = el.dataset;
        const p = {
          el,
          i,
          swing: $('[data-piece-swing]', el),
          card: $('[data-piece-card]', el),
          shadow: $('[data-piece-shadow]', el),
          faces: $$('[data-face]', el),
          variants: $$('[data-piece-variants] button', el),
          title: d.title || '',
          sub: d.sub || '',
          url: d.url || '',
          price: d.price || '',
          variant: d.variant || '',
          quick: d.quick === 'true',
          available: d.available === 'true',
          demo: d.demo === 'true',
          mode: d.mode || 'auto',
          ang: 0,
          w: 0,
          k: 38 + ((i * 7) % 5) * 3.2,
          c: 2.4 + ((i * 3) % 4) * 0.35,
          ph: i * 1.9,
          f: 0,
          flipT: null,
          shDirty: true,
        };
        p.hasBack = p.faces.length > 1;
        if (p.hasBack && d.backFirst === 'true') p.f = 1;
        const sel = p.variants.filter((b) => b.getAttribute('aria-pressed') === 'true')[0];
        if (sel) {
          p.variant = sel.dataset.id;
          p.price = sel.dataset.price;
        }
        return p;
      });
      const N = pieces.length;
      if (!N) return;
      const steps = Math.max(1, N - 1);

      /* Immer nur eine Seite zeigen. Manche Browser (v. a. am PC) ignorieren
         backface-visibility und malen sonst Vorder- und Rückseite übereinander. */
      const setSide = (p) => {
        if (!p.hasBack) return;
        const b = Math.cos(p.f * Math.PI) < 0;
        if (b === p.sideB) return;
        p.sideB = b;
        p.faces[0].style.visibility = b ? 'hidden' : 'visible';
        p.faces[1].style.visibility = b ? 'visible' : 'hidden';
      };
      pieces.forEach((p) => {
        if (!p.hasBack) return;
        p.faces.forEach((f) => {
          f.style.webkitBackfaceVisibility = 'visible';
          f.style.backfaceVisibility = 'visible';
        });
        setSide(p);
      });

      for (let m = -0.5; m < N + 1; m += 2) {
        const mount = doc.createElement('span');
        mount.className = 'mount';
        mount.style.left = 'calc(' + m + ' * var(--step))';
        track.insertBefore(mount, track.firstChild);
      }

      /* Bilder vermessen, Schatten anlegen, dann einblenden */
      pieces.forEach((p) => {
        const imgs = p.faces.map((f) => $('img', f));
        const ready = () => {
          p.el.classList.add('is-ready');
        };
        const jobs = imgs.map((img) => probeImage(img && img.dataset.probe));
        Promise.all(jobs).then((res) => {
          const first = res[0];
          if (p.mode === 'card' || (p.mode === 'auto' && first && first.opaque)) p.el.classList.add('piece--card');
          else if (p.mode === 'cutout' || (first && !first.opaque)) p.el.classList.remove('piece--card');
          const card = p.el.classList.contains('piece--card');
          if (!card) {
            p.faces.forEach((f, i) => fitFace(f, res[i]));
            const src = imgs[p.f > 0.5 && imgs[1] ? 1 : 0];
            if (src && p.shadow) {
              const face = p.faces[p.f > 0.5 && imgs[1] ? 1 : 0];
              const sh = doc.createElement('img');
              sh.alt = '';
              sh.src = src.currentSrc || src.src;
              ['--fh', '--ft', '--fx'].forEach((v) => {
                const val = face.style.getPropertyValue(v);
                if (val) p.shadow.style.setProperty(v, val);
              });
              p.shadow.appendChild(sh);
            }
          }
          ready();
        });
        window.setTimeout(ready, 3600);
      });

      let railTop = 0, railRange = 1, step = 300, wide = false;
      let P = 0, X = 0, Xprev = null, vel = 0, idx = -1, moved = false;

      function measure() {
        wide = S.vw >= 820;
        railTop = rail.getBoundingClientRect().top + window.scrollY;
        railRange = Math.max(1, rail.offsetHeight - pin.offsetHeight);
        step = N > 1 ? pieces[1].el.offsetLeft - pieces[0].el.offsetLeft : pin.offsetWidth;
        if (floor && info) floor.style.height = pin.offsetHeight - info.offsetTop + (wide ? 24 : 16) + 'px';
        Xprev = null;
      }
      const pad2 = (n) => String(n).padStart(2, '0');
      const side = (p) => (p.hasBack ? (p.f > 0.5 ? STR.back : STR.front) : '');
      const subLine = (p, s) => [p.sub, s === undefined ? side(p) : s].filter(Boolean).join(' · ');

      function setAdd(p) {
        const b = ui.add;
        if (!b) return;
        b.disabled = false;
        if (p.demo) {
          b.textContent = STR.demo || '';
          b.disabled = true;
        } else if (!p.available) {
          b.textContent = STR.soldOut || '';
          b.disabled = true;
        } else if (!p.quick) {
          b.textContent = STR.toProduct || '';
        } else {
          b.textContent = STR.addToCart || '';
        }
      }
      function showInfo(i, anim) {
        const p = pieces[i];
        ui.name.textContent = p.title;
        if (p.url) ui.name.setAttribute('href', p.url);
        else ui.name.removeAttribute('href');
        ui.sub.textContent = subLine(p);
        ui.price.textContent = p.price;
        ui.count.textContent = pad2(i + 1) + ' / ' + pad2(N);
        ui.opts.textContent = '';
        p.variants.forEach((b) => ui.opts.appendChild(b));
        ui.opts.hidden = !p.variants.length;
        setAdd(p);
        if (anim) {
          tween({
            dur: 420,
            update: (q) => {
              ui.text.style.opacity = q;
              ui.text.style.transform = 'translateY(' + (1 - q) * 10 + 'px)';
              ui.price.style.opacity = q;
            },
          });
        }
      }
      function flip(i) {
        const p = pieces[i];
        const from = p.f;
        const to = p.hasBack ? (p.f > 0.5 ? 0 : 1) : p.f + 2;
        if (p.flipT) tweens.delete(p.flipT);
        p.w += (i % 2 ? -1 : 1) * 46;
        if (RM) {
          p.f = p.hasBack ? to : 0;
          p.shDirty = true;
        } else {
          p.flipT = tween({
            dur: 950,
            ease: E.io,
            from,
            to,
            update: (q) => {
              p.f = q;
            },
            done: () => {
              if (!p.hasBack) p.f = 0;
              p.flipT = null;
              p.shDirty = true;
            },
          });
        }
        if (i === idx && p.hasBack) ui.sub.textContent = subLine(p, to > 0.5 ? STR.back : STR.front);
      }
      function goTo(i) {
        i = clamp(i, 0, N - 1);
        window.scrollTo({ top: railTop + (railRange * i) / steps, behavior: RM ? 'auto' : 'smooth' });
      }

      pieces.forEach((p) => {
        p.card.addEventListener('click', () => {
          if (moved) return;
          if (p.i !== idx) goTo(p.i);
          else flip(p.i);
        });
        p.variants.forEach((b) =>
          b.addEventListener('click', () => {
            p.variants.forEach((o) => o.setAttribute('aria-pressed', o === b ? 'true' : 'false'));
            p.variant = b.dataset.id;
            p.price = b.dataset.price;
            if (p.i === idx) ui.price.textContent = p.price;
          })
        );
      });
      $('[data-rail-prev]', rail).addEventListener('click', () => goTo(idx - 1));
      $('[data-rail-next]', rail).addEventListener('click', () => goTo(idx + 1));
      if (ui.flip) ui.flip.addEventListener('click', () => flip(Math.max(0, idx)));
      if (ui.add) {
        ui.add.addEventListener('click', () => {
          const p = pieces[Math.max(0, idx)];
          if (p.demo || !p.available) return;
          if (!p.quick || !p.variant) {
            window.location.href = p.url;
            return;
          }
          ui.add.disabled = true;
          addToCart({ items: [{ id: Number(p.variant), quantity: 1 }] }, p.title).then(() => {
            ui.add.disabled = false;
          });
        });
      }

      /* Ziehen: seitliche Bewegung wird in Scroll-Weg übersetzt */
      let drag = null;
      pin.addEventListener('pointerdown', (e) => {
        if (e.target.closest('[data-rail-info]')) return;
        drag = { x: e.clientX, y: e.clientY, id: e.pointerId, on: false };
        moved = false;
      });
      window.addEventListener('pointermove', (e) => {
        if (!drag || e.pointerId !== drag.id) return;
        const dx = e.clientX - drag.x;
        const dy = e.clientY - drag.y;
        if (!drag.on) {
          if (Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy) * 1.2) {
            drag.on = true;
            moved = true;
            pin.classList.add('is-drag');
          } else return;
        }
        drag.x = e.clientX;
        window.scrollBy(0, (-dx * railRange) / (steps * step));
      });
      const endDrag = () => {
        if (!drag) return;
        drag = null;
        pin.classList.remove('is-drag');
        window.setTimeout(() => {
          moved = false;
        }, 60);
      };
      window.addEventListener('pointerup', endDrag);
      window.addEventListener('pointercancel', endDrag);

      measure();
      onResize(measure);
      window.addEventListener('load', measure);
      if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(measure);
      showInfo(0, false);
      idx = 0;

      onFrame((s) => {
        if (!rail.isConnected) return false;
        const sy = s.sy;
        const dt = s.dt;
        const pt = clamp((sy - railTop) / railRange);
        P = RM ? pt : P + (pt - P) * (1 - Math.exp(-dt * 9));
        const entry = clamp((sy + s.vh - railTop) / s.vh);
        const fx = wide && N > 2 ? lerp(0.27, 0.73, P) : 0.5;
        X = s.vw * fx - P * steps * step + (RM ? 0 : (1 - E.out(entry)) * s.vw * 0.55);
        if (Xprev === null) Xprev = X;
        vel = lerp(vel, (X - Xprev) / dt, 0.35);
        Xprev = X;
        if (entry <= 0 || sy > railTop + railRange + s.vh) return;

        track.style.transform = 'translate3d(' + X.toFixed(2) + 'px,0,0)';
        if (wallType) wallType.style.transform = 'translate3d(' + (s.vw * 0.08 + (X - s.vw * fx) * 0.32).toFixed(2) + 'px,0,0)';
        if (prog) prog.style.transform = 'scaleX(' + P.toFixed(4) + ')';
        if (hint) hint.style.opacity = (0.7 * (1 - clamp(P * 5))).toFixed(3);
        const target = RM ? 0 : clamp(vel * 0.011, -13, 13);
        for (let i = 0; i < N; i++) {
          const p = pieces[i];
          p.w += (-p.k * (p.ang - target) - p.c * p.w) * dt;
          p.ang += p.w * dt;
          const idle = RM ? 0 : Math.sin((s.t / 1000) * 0.9 + p.ph) * 0.45;
          const d = Math.min(1, Math.abs(i - P * steps));
          p.swing.style.transform = 'rotate(' + (p.ang + idle).toFixed(3) + 'deg)';
          p.card.style.transform = 'perspective(1100px) rotateY(' + (p.f * 180).toFixed(2) + 'deg) scale(' + (1.04 - 0.07 * d).toFixed(4) + ')';
          setSide(p);
          if ((p.flipT || p.shDirty) && p.shadow) {
            const k = Math.max(0.2, Math.abs(Math.cos(p.f * Math.PI)));
            p.shadow.style.transform = 'translate(16px,20px) scaleX(' + k.toFixed(3) + ')';
            p.shDirty = !!p.flipT;
          }
        }
        const ni = Math.round(P * steps);
        if (ni !== idx) {
          idx = ni;
          showInfo(idx, true);
        }
      });
    });
  }

  /* ---------------------------------------------------------- Einblenden */
  const reveals = [];
  function initReveal(scope) {
    $$('[data-rv]', scope).forEach((el) => {
      if (el.__rv) return;
      el.__rv = true;
      const kind = el.dataset.rv;
      const o = { el, kind, delay: parseFloat(el.dataset.rvDelay) || 0, done: false, p: 0 };
      if (kind === 'photo') {
        o.m = $('.ph__m', el) || el;
        o.img = $('img,video', o.m);
        const shots = el.parentNode && el.parentNode.classList.contains('shots');
        if (shots) {
          const n = Array.prototype.indexOf.call(el.parentNode.children, el);
          o.par = n === 0 ? 0 : n % 2 ? -0.05 : -0.11;
        } else o.par = 0;
      }
      if (!RM) {
        if (kind === 'line') el.style.transform = 'translateY(108%)';
        else if (kind === 'wipe') el.style.clipPath = 'inset(-20% 100% -20% 0)';
        else if (kind === 'photo') o.m.style.clipPath = 'inset(0 0 100% 0)';
        else if (kind === 'fade') {
          el.style.opacity = 0;
          el.style.transform = 'translateY(26px)';
        }
        reveals.push(o);
      }
    });
  }
  function runReveal(o, extra) {
    o.done = true;
    const delay = o.delay + extra + introDelayLeft();
    const el = o.el;
    if (o.kind === 'line') tween({ delay, dur: 1000, ease: E.out5, update: (p) => { el.style.transform = 'translateY(' + (1 - p) * 108 + '%)'; } });
    else if (o.kind === 'wipe') tween({ delay, dur: 1300, ease: E.io, update: (p) => { el.style.clipPath = 'inset(-20% ' + (1 - p) * 100 + '% -20% 0)'; } });
    else if (o.kind === 'photo') tween({ delay, dur: 1300, ease: E.out5, update: (p) => { o.p = p; o.m.style.clipPath = 'inset(0 0 ' + (1 - p) * 100 + '% 0)'; } });
    else tween({ delay, dur: 800, update: (p) => { el.style.opacity = p; el.style.transform = 'translateY(' + (1 - p) * 26 + 'px)'; } });
  }
  let introEnd = 0;
  function introDelayLeft() {
    return Math.max(0, introEnd - S.t);
  }
  function revealFrame(s) {
    let batch = 0;
    for (let i = reveals.length - 1; i >= 0; i--) {
      const o = reveals[i];
      if (!o.el.isConnected) {
        reveals.splice(i, 1);
        continue;
      }
      if (o.done && o.kind !== 'photo') {
        reveals.splice(i, 1);
        continue;
      }
      const r = o.el.getBoundingClientRect();
      if (r.bottom < -300 || r.top > s.vh + 300) continue;
      if (!o.done && r.top < s.vh * 0.9) {
        runReveal(o, o.kind === 'fade' ? batch * 70 : 0);
        if (o.kind === 'fade') batch++;
      }
      if (o.kind === 'photo') {
        const c = r.top + r.height / 2 - s.vh / 2;
        if (o.par) o.el.style.transform = 'translate3d(0,' + (c * o.par).toFixed(2) + 'px,0)';
        if (o.img) o.img.style.transform = 'scale(' + (1.2 - 0.14 * o.p).toFixed(4) + ') translate3d(0,' + (c * -0.03).toFixed(2) + 'px,0)';
      }
    }
  }

  /* ------------------------------------------------------------ Kopfzeile */
  function initHeader() {
    const nav = doc.getElementById('Nav');
    if (!nav) return;
    const hide = nav.dataset.hideOnScroll !== 'false';
    let zones = $$('[data-nav="light"]');
    doc.addEventListener('shopify:section:load', () => {
      zones = $$('[data-nav="light"]');
    });
    let show = 1, k = 1;
    onFrame((s) => {
      const navY = 34;
      let light = false;
      for (let i = 0; i < zones.length; i++) {
        const z = zones[i];
        if (!z.isConnected) continue;
        const r = z.getBoundingClientRect();
        if (r.top <= navY && r.bottom > navY) {
          light = true;
          break;
        }
      }
      nav.classList.toggle('nav--light', light);
      nav.classList.toggle('nav--solid', s.sy > 30);
      if (!hide || s.sy < 140 || s.vy < -60 || drawerOpen) show = 1;
      else if (s.vy > 60) show = 0;
      k = RM ? show : k + (show - k) * (1 - Math.exp(-s.dt * 9));
      nav.style.transform = k > 0.999 ? '' : 'translate3d(0,' + ((k - 1) * 115).toFixed(2) + '%,0)';
    });

    /* Menü fürs Handy */
    const drawer = doc.getElementById('NavDrawer');
    const openBtn = $('[data-drawer-open]', nav);
    let drawerOpen = false;
    if (drawer && openBtn) {
      const close = () => {
        if (!drawerOpen) return;
        drawerOpen = false;
        drawer.classList.remove('is-open');
        openBtn.setAttribute('aria-expanded', 'false');
        window.setTimeout(() => {
          if (!drawerOpen) drawer.hidden = true;
        }, 520);
        openBtn.focus();
      };
      const open = () => {
        drawerOpen = true;
        drawer.hidden = false;
        void drawer.offsetWidth;
        drawer.classList.add('is-open');
        openBtn.setAttribute('aria-expanded', 'true');
        const first = $('[data-drawer-close]', drawer);
        if (first) first.focus();
      };
      openBtn.addEventListener('click', () => (drawerOpen ? close() : open()));
      $$('[data-drawer-close]', drawer).forEach((b) => b.addEventListener('click', close));
      doc.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
      });
      doc.addEventListener('click', (e) => {
        if (drawerOpen && !drawer.contains(e.target) && !openBtn.contains(e.target)) close();
      });
    }
  }

  /* ------------------------------------------------------------ Warenkorb */
  let toastTimer = 0;
  function say(text, link) {
    const toast = doc.getElementById('Toast');
    if (!toast) return;
    toast.textContent = text;
    if (link) {
      const a = doc.createElement('a');
      a.href = link.href;
      a.textContent = link.label;
      toast.appendChild(a);
    }
    toast.classList.add('on');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('on'), 4200);
  }
  function setCartCount(n) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = n;
    });
    $$('[data-cart-bubble]').forEach((el) => {
      tween({
        dur: 500,
        update: (q) => {
          el.style.transform = 'scale(' + (1 + 0.35 * Math.sin(q * Math.PI)) + ')';
        },
      });
    });
  }
  function refreshCart() {
    return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then((r) => r.json())
      .then((cart) => setCartCount(cart.item_count))
      .catch(() => {});
  }
  /* body: FormData oder {items:[{id, quantity}]} */
  function addToCart(body, title) {
    const isForm = typeof FormData !== 'undefined' && body instanceof FormData;
    const headers = { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
    if (!isForm) headers['Content-Type'] = 'application/json';
    return fetch(T.routes.cartAdd + '.js', {
      method: 'POST',
      headers,
      credentials: 'same-origin',
      body: isForm ? body : JSON.stringify(body),
    })
      .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
      .then((res) => {
        if (!res.ok) throw res.j;
        if (T.cartAddBehavior === 'cart') {
          window.location.href = T.routes.cart;
          return true;
        }
        const name = title || (res.j.items && res.j.items[0] && res.j.items[0].product_title) || res.j.product_title || '';
        say((STR.added || '').replace('[title]', name), { href: T.routes.cart, label: STR.viewCart || '' });
        refreshCart();
        return true;
      })
      .catch((err) => {
        say((err && (err.description || err.message)) || STR.addError || '');
        return false;
      });
  }

  function initCartPage(scope) {
    $$('[data-cart-form]', scope).forEach((form) => {
      let timer = 0;
      const submit = () => {
        window.clearTimeout(timer);
        timer = window.setTimeout(() => form.submit(), 500);
      };
      $$('.qty', form).forEach((q) => bindQty(q, submit));
    });
  }
  function bindQty(q, onChange) {
    const input = $('input', q);
    if (!input || q.__qty) return;
    q.__qty = true;
    const min = parseInt(input.min, 10) || 0;
    $$('[data-qty]', q).forEach((b) =>
      b.addEventListener('click', () => {
        const v = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(b.dataset.qty, 10));
        if (String(v) === input.value) return;
        input.value = v;
        if (onChange) onChange();
      })
    );
    if (onChange) input.addEventListener('change', onChange);
  }

  /* --------------------------------------------------------- Produktseite */
  function initProduct(scope) {
    $$('[data-product]', scope).forEach((el) => {
      if (el.__product) return;
      el.__product = true;
      const form = $('form[data-type="add-to-cart-form"]', el);
      const idInput = $('[data-variant-input]', el);
      const button = $('[data-add-button]', el);
      const label = $('[data-add-label]', el);
      const priceBox = $('[data-product-price]', el);
      const radios = $$('[data-option-position]', el);
      const media = $('.pdp__media', el);
      let variants = [];
      try {
        variants = JSON.parse($('[data-product-variants]', el).textContent) || [];
      } catch (e) {}
      $$('.qty', el).forEach((q) => bindQty(q));

      const selected = () => {
        const out = [];
        radios.forEach((r) => {
          if (r.checked) out[parseInt(r.dataset.optionPosition, 10) - 1] = r.value;
        });
        return out;
      };
      const match = (opts) => variants.filter((v) => v.options.every((o, i) => o === opts[i]))[0];
      const update = (push) => {
        const opts = selected();
        const v = match(opts);
        radios.forEach((r) => {
          const pos = parseInt(r.dataset.optionPosition, 10) - 1;
          const probe = opts.slice();
          probe[pos] = r.value;
          const hit = match(probe);
          r.classList.toggle('is-off', !hit || !hit.available);
        });
        if (!v) {
          if (button) button.disabled = true;
          if (label) label.textContent = STR.unavailable || '';
          return;
        }
        if (idInput) idInput.value = v.id;
        if (button) button.disabled = !v.available;
        if (label) label.textContent = v.available ? STR.addToCart || '' : STR.soldOut || '';
        const tpl = $('template[data-variant-price="' + v.id + '"]', el);
        if (tpl && priceBox) priceBox.innerHTML = tpl.innerHTML;
        if (push && window.history.replaceState) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (push && v.featured_media && media) {
          const m = $('[data-media-id="' + v.featured_media.id + '"]', media);
          if (m && media.scrollWidth > media.clientWidth + 4) media.scrollTo({ left: m.offsetLeft - media.offsetLeft, behavior: RM ? 'auto' : 'smooth' });
        }
      };
      radios.forEach((r) => r.addEventListener('change', () => update(true)));
      if (radios.length) update(false);

      if (form) {
        form.addEventListener('submit', (e) => {
          if (!window.fetch || !window.FormData) return;
          e.preventDefault();
          if (button) button.disabled = true;
          addToCart(new FormData(form)).then(() => {
            if (button) button.disabled = false;
          });
        });
      }
    });
  }

  /* ---------------------------------------------------------- Kleinkram */
  function initMisc(scope) {
    $$('[data-sort]', scope).forEach((sel) =>
      sel.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      })
    );
    $$('[data-toggle-recover]', scope).forEach((a) =>
      a.addEventListener('click', (e) => {
        e.preventDefault();
        const login = $('[data-login-panel]');
        const rec = $('[data-recover-panel]');
        if (!login || !rec) return;
        rec.hidden = !rec.hidden;
        login.hidden = !rec.hidden;
      })
    );
    if (window.location.hash === '#recover') {
      const login = $('[data-login-panel]');
      const rec = $('[data-recover-panel]');
      if (login && rec) {
        rec.hidden = false;
        login.hidden = true;
      }
    }
    $$('form[data-confirm]', scope).forEach((f) =>
      f.addEventListener('submit', (e) => {
        if (!window.confirm(f.dataset.confirm)) e.preventDefault();
      })
    );
    $$('[data-country]', scope).forEach((country) => {
      const formEl = country.closest('form');
      const wrap = formEl && $('[data-province-wrap]', formEl);
      const prov = formEl && $('[data-province]', formEl);
      if (country.dataset.default) country.value = country.dataset.default;
      const fill = () => {
        if (!wrap || !prov) return;
        const opt = country.options[country.selectedIndex];
        let list = [];
        try {
          list = JSON.parse((opt && opt.getAttribute('data-provinces')) || '[]');
        } catch (e) {}
        prov.textContent = '';
        list.forEach((pair) => {
          const o = doc.createElement('option');
          o.value = pair[0];
          o.textContent = pair[1];
          prov.appendChild(o);
        });
        wrap.hidden = !list.length;
        if (prov.dataset.default) prov.value = prov.dataset.default;
      };
      country.addEventListener('change', fill);
      fill();
    });
  }

  /* ---------------------------------------------------------------- Start */
  function initSections(scope, heroDelay) {
    initHero(scope, heroDelay);
    initMarquee(scope);
    initRail(scope);
    initReveal(scope);
    initLogoDraw(scope);
    initProduct(scope);
    initCartPage(scope);
    initMisc(scope);
  }

  function start() {
    initIntro();
    introEnd = S.t + introDelay;
    initHeader();
    initSections(doc, introDelay);
    onFrame(revealFrame);
    measureAll();
    window.addEventListener('resize', measureAll);
    window.addEventListener('load', measureAll);
    window.requestAnimationFrame(frame);
  }

  doc.addEventListener('shopify:section:load', (e) => {
    initSections(e.target, 0);
    measureAll();
  });
  if (DESIGN) root.classList.add('is-design');

  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start);
  else start();
})();
